import { render, staticRenderFns } from "./InputLight.vue?vue&type=template&id=f3517a5a"
import script from "./InputLight.vue?vue&type=script&lang=js"
export * from "./InputLight.vue?vue&type=script&lang=js"
import style0 from "./InputLight.vue?vue&type=style&index=0&id=f3517a5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports